import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changePage
} from '../../../action/VodAction'
import { VODPlayListColor } from '../../../JS/setColors'

class VODMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noImage: [],
    }
  }
  pageChange = (pageNumber) => {
    this.props.changePage(pageNumber);
  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }

  componentDidMount() {
    VODPlayListColor(this.props.menuColor);
  }

  render() {
    //console.log("VODData", this.props.mainCategories);
    return (
      <div id="movie-widgets" className="movie-widgets">
        <h4>Search movies by</h4>
        <ul className="movie-widgets-list">
          {/*<li
            id="resume-play"
            data-target=""
            style={{
              background: " url('img/movies-vod/cover-ff.jpg') center center no-repeat",
              backgroundSize: "cover"
            }}>
            <span className="movie-thumb-text">
              Resume Playback: Fast and the Furious
          </span>
          </li>*/}
          <li id="search-keyword" data-target="movie-search-keyword" onClick={() => { this.pageChange(3) }}>
            <div><i className="fa fa-search" style={{ width: "100%", height: "100%" }}></i></div>
            <span>Keyword</span>
          </li>
          {this.props.mainCategories ?
            this.props.mainCategories.map((iterator, index) => {
              if (iterator.name) {
                return (
                  <li
                    style={this.state.noImage.indexOf(iterator.id) === -1 ? {
                      background: `url('${iterator.imageUrl ? iterator.imageUrl : null}') center center no-repeat`,
                      backgroundSize: "cover"
                    } : null}
                    id="search-language"
                    data-target="movie-search-lang"
                    onClick={() => { this.pageChange(iterator.name) }}>
                    <img style={{ display: "none" }}
                      alt="not found"
                      src={iterator.imageUrl}
                      onError={() => { this.imageNotfound(iterator.id) }}
                    />
                    {
                      this.state.noImage.indexOf(iterator.id) !== -1 || !iterator.imageUrl ?
                        iterator.name === "Language" ?
                          <a><i class="fa fa-comments-o"></i></a> :
                          <a><i class="fa fa-video-camera"></i></a> : null
                    }
                    <span className="movie-thumb-text">{iterator.name}</span>
                  </li>
                )
              } else {
                return (
                  <li
                    style={{
                      background: `#eeeeee`,
                      backgroundSize: "cover"
                    }}
                    id="search-language"
                    data-target="movie-search-lang"
                    onClick={() => { this.pageChange(iterator.name) }}>
                    <div><i className="fa fa-video-camera"></i></div>
                    <span className="movie-thumb-text">{iterator.name}</span>
                  </li>
                )
              }
            }) : null
          }
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    mainCategories: state.store.vod.VODData ?
      state.store.vod.VODData.channelMainCategoryOrder : null,
      menuColor: state.store.home.MenuColor
    
  }
}

export default connect(
  mapStateToProps, {
  changePage
}
)(VODMenu);